import React from 'react';
import { Box, Typography } from '@mui/material';

export const DocumentsDashboard: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4">Documents Dashboard</Typography>
    </Box>
  );
}; 